import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction } from '../../serviceCall'

export const sendPushNotificationApi = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        formDataCommonFunction(data, apiConstants.MESSAGING.SEND_PUSH_NOTIFICATION)
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
} 
